import React from 'react';
import { useCounterpartApplication } from '../../contexts/useCounterpartApplication';
import { Spinner } from '../_new/Spinner';
import PersonalDetails from './PersonalDetails';

export const PairDetails = () => {
	const { data, isLoading } = useCounterpartApplication();

	if (isLoading || !data) {
		return <Spinner center />;
	}

	return <PersonalDetails applicationData={data} />;
};
